import { IManualQuoteReason, IQuoteRequest } from 'features/BookingFlow'
import { useState } from 'react'

export type ManualQuoteType =
  | 'HEAVY_CARGO'
  | 'DANGEROUS_GOODS'
  | 'INVALID_PORT'
  | 'default'
  | 'customMode'
  | 'INVALID_REQUEST'

function buildManualQuoteReasonMessage(manualQuoteReasons?: IManualQuoteReason[]): string | undefined {
  if (!manualQuoteReasons || manualQuoteReasons.length === 0) {
    return undefined
  }
  return manualQuoteReasons.map((reason) => reason.message).join(', ')
}

export const useManualQuoteDialogState = () => {
  const [quoteRequest, setQuoteRequest] = useState<IQuoteRequest | null>(null)
  const [quoteSheetId, setQuoteSheetId] = useState<string | undefined>(undefined)
  const [manualQuoteType, setManualQuoteType] = useState<ManualQuoteType>('default')
  const [manualQuoteReasonMessage, setManualQuoteReasonMessage] = useState<string | undefined>(undefined)

  const triggerManualQuoteDialog = (
    qr: IQuoteRequest,
    id?: string,
    type?: ManualQuoteType,
    manualQuoteReasons?: IManualQuoteReason[]
  ): void => {
    setQuoteRequest(qr)
    setManualQuoteReasonMessage(buildManualQuoteReasonMessage(manualQuoteReasons))
    setQuoteSheetId(id || '')
    if (type) {
      setManualQuoteType(type)
    }
  }

  const closeManualQuoteDialog = () => {
    setQuoteRequest(null)
    setManualQuoteReasonMessage(undefined)
  }

  const isOpen = !!quoteRequest

  return {
    isOpen,
    quoteRequest,
    quoteSheetId,
    manualQuoteType,
    triggerManualQuoteDialog,
    closeManualQuoteDialog,
    manualQuoteReasonMessage,
  }
}

export type ManualQuoteDialogState = ReturnType<typeof useManualQuoteDialogState>
